export function putZeroInStartString(str: string | number) {
  if (typeof str === 'number') return str.toString().padStart(2, '0')
  return str.padStart(2, '0')
}